module.exports = "/_next/static/images/piggy-duotone-e0804358b6a60d632148284c9eb3db9a.svg";